import React from 'react';

function Hero() {
  const scrollToDownload = () => {
    const element = document.getElementById('download');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="pt-32 pb-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-awa-green-light mb-8">
            <span className="text-awa-green text-sm font-bold">🏆 المنصة العقارية السورية الأولى</span>
          </div>

          {/* Main Heading */}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-awa-dark mb-6 leading-tight">
            AWA - العقار بين يديك
            <br />
            <span className="text-awa-green">منصتك العقارية الموثوقة</span>
          </h1>

          {/* Description */}
          <p className="text-lg sm:text-xl text-awa-gray mb-10 max-w-3xl mx-auto leading-relaxed">
            المنصة العقارية السورية الأولى التي تجمع الباحثين عن العقارات مع أصحاب العقارات بشكل مباشر.
            ابحث عن منزلك، أرضك، أو مكتبك المثالي بسهولة وأمان.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button
              onClick={scrollToDownload}
              className="gradient-bg text-white px-8 py-4 rounded-full font-bold text-lg hover:opacity-90 transition-opacity shadow-lg w-full sm:w-auto"
            >
              حمّل التطبيق مجاناً
            </button>
            <button
              onClick={() => document.getElementById('features').scrollIntoView({ behavior: 'smooth' })}
              className="bg-white text-awa-green border-2 border-awa-green px-8 py-4 rounded-full font-bold text-lg hover:bg-awa-green-light transition-colors w-full sm:w-auto"
            >
              اعرف المزيد
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
